// extracted by LIB_CSS_EXTRACT_LOADER
import "./gradient-text_module.css"
export default {"root":"root-lzRVsJ","neon":"neon-gZ2mQJ","text":"text-P04R0z"};